var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_vm._t("gnb"),_c('div',{attrs:{"id":"outer-wrap"}},[(_vm.useLeft)?_c('LeftMenu'):_vm._e(),_c('SubContentTemplate',{attrs:{"isFull":!_vm.useLeft},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }